import { gsap } from 'gsap';
import { Container, Sprite } from '../../odie';
import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { PositionType } from '../../lib/defs/types';

const manifest = {
  hammer: 'fx.dart/fx.dart.hammer.png',
};

export class DartAnimation extends Container implements IAnimation {
  private _hammer!: Sprite;
  private _position: PositionType;
  public onImpact?: () => void;

  public static assets(): string[] {
    return [manifest.hammer];
  }

  constructor(position: PositionType) {
    super();
    this._position = position;
  }

  public async start(): Promise<void> {
    this.x = this._position.x + 100;
    this.y = this._position.y + 50;

    this._hammer = Sprite.from(manifest.hammer);
    this._hammer.anchorX = 0.5;
    this._hammer.anchorY = 0.8;
    this._hammer.scaleX = 0;
    this._hammer.scaleY = 0;
    this._hammer.rotation = 5;
    this.addChild(this._hammer);

    await gsap.to(this._hammer, {
      scaleX: 0.7,
      scaleY: 0.7,
      x: 80,
      y: -10,
      rotation: -1,
      duration: 0.7,
      ease: 'quad.out',
    });

    app.sound.play('puzzle-dart');

    await gsap.to(this._hammer, {
      rotation: 1,
      scaleX: 0.6,
      scaleY: 0.5,
      x: 0,
      y: 0,
      duration: 0.2,
      ease: 'expo.in',
    });

    this.onImpact?.();

    await gsap.to(this._hammer, {
      scaleX: 1,
      scaleY: 1,
      x: 80,
      y: -10,
      rotation: -1,
      duration: 0.7,
      ease: 'sine.out',
    });

    await gsap.to(this._hammer, {
      scaleX: 0,
      scaleY: 0,
      rotation: 0,
      duration: 0.3,
      ease: 'sine.inOut',
    });
  }

  public stop() {
    this.removeChild(this._hammer);
  }
}
